import { useCallback, useEffect, useState } from 'react';
import { usePagination } from '../components/common-grid-view-helpers';
import { IFileDataWithSharing } from '../utils/file-manager';
// import { useMockFilesQuery } from './use-mock-files-query';
// import { useMediaFilesQuery } from './use-media-files-query';
// import { useFileManagerConfig } from './use-file-manager-config';

export const useGridViewData = (filters: any, queryBuilder: (params: any) => any, queryHook: (params: any, extraParams?: any) => any, extraParams?: any, onDelete?: (file: IFileDataWithSharing) => Promise<void>) => {
  const { paginationState, updateTotalCount, loadMore } = usePagination(filters);
  const [combinedData, setCombinedData] = useState<ReturnType<typeof queryHook>['data']>([]);

  const queryParams = queryBuilder({
    page: 0,
    pageSize: (paginationState.pageIndex + 1) * paginationState.pageSize,
    filters,
  });

  const { data, isLoading, error, refetch } = queryHook(queryParams, extraParams);

  useEffect(() => {
    if (!data) return;
    
    setCombinedData(data.data);

    if (data?.totalCount !== undefined) {
      updateTotalCount(data.totalCount);
    }
  }, [data, paginationState.pageIndex, updateTotalCount]);

  const handleLoadMore = useCallback(() => {
    if (combinedData && combinedData.length < data?.totalCount) {
      loadMore();
    }
  }, [combinedData, data?.totalCount, loadMore]);

  const handleDelete = useCallback(
    async(file: IFileDataWithSharing) => {
      try {
        await onDelete?.(file);
        refetch();
      } catch (error) {
        console.error('Error deleting file:', error);
      }
    },
    [onDelete, refetch]
  );

  return {
    data: {
      data: combinedData,
      totalCount: data?.totalCount,
    },
    isLoading,
    error,
    handleLoadMore,
    handleDelete,
  };
};
